import { render } from "./MobileNameDialog.vue?vue&type=template&id=317f732f&scoped=true&ts=true"
import script from "./MobileNameDialog.vue?vue&type=script&lang=ts"
export * from "./MobileNameDialog.vue?vue&type=script&lang=ts"

import "./MobileNameDialog.vue?vue&type=style&index=0&id=317f732f&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317f732f"]])

export default __exports__